// src/store/modules/auth.js
import {
    APPEARANCE_MODES,
    normalizeAppearanceMode,
    syncAppearanceMode,
} from '@/utils/appearance';
import { userSelf as fetchUserSelf } from '@/api/users';

const state = {
    token: localStorage.getItem('token') || '',
    userSelf: null,
    menuItems: [],
    appearanceMode: APPEARANCE_MODES.SYSTEM,
    sessionReady: false,
};

const mutations = {
    setToken(state, token) {
        state.token = token;
    },
    clearToken(state) {
        state.token = '';
    },
    setUserSelf(state, user) {
        state.userSelf = user;
        if (user && user.appearance_mode) {
            state.appearanceMode = normalizeAppearanceMode(
                user.appearance_mode
            );
        }
    },
    clearUserSelf(state) {
        state.userSelf = null;
        state.menuItems = [];
        state.sessionReady = false;
    },
    setMenuItems(state, menuItems) {
        state.menuItems = Array.isArray(menuItems) ? menuItems : [];
    },
    setAppearanceMode(state, mode) {
        state.appearanceMode = normalizeAppearanceMode(mode);
    },
    setSessionReady(state, ready) {
        state.sessionReady = ready;
    },
};

const actions = {
    signin({ commit }, token) {
        commit('setToken', token);
        localStorage.setItem('token', token);
    },
    signout({ commit }) {
        commit('clearToken');
        commit('clearUserSelf');
        localStorage.removeItem('token');
    },
    async hydrateCurrentUser(
        { commit, state },
        { force = false, setReady = true } = {}
    ) {
        if (!force && state.sessionReady && state.userSelf) {
            return {
                user_data: state.userSelf,
                menu_items: state.menuItems,
            };
        }

        const response = await fetchUserSelf();
        const user = response?.user_data || null;
        const menuItems = response?.menu_items || [];
        const appearanceMode = normalizeAppearanceMode(user?.appearance_mode);

        syncAppearanceMode(appearanceMode);
        commit('setUserSelf', user);
        commit('setMenuItems', menuItems);
        commit('setAppearanceMode', appearanceMode);
        commit('setSessionReady', setReady);

        return response;
    },
    updateUserSelf({ commit }, user) {
        commit('setUserSelf', user);
        commit('setSessionReady', true);
    },
    updateMenuItems({ commit }, menuItems) {
        commit('setMenuItems', menuItems);
        commit('setSessionReady', true);
    },
    updateAppearanceMode({ commit }, mode) {
        commit('setAppearanceMode', mode);
    },
    clearUserSelf({ commit }) {
        commit('clearUserSelf');
    },
};

const getters = {
    isAuthenticated: state => !!state.token,
    menuItems: state => state.menuItems,
    appearanceMode: state => state.appearanceMode,
    sessionReady: state => state.sessionReady,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
